<template>
  <div style="padding: 0 2px">
    <div class="ranking">
      <div class="flex_between ranking_title_top">
        <div class="title">{{ $transform("MARKET MOVERS") }}</div>
        <el-tabs class="tabs" v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            :label="item"
            :name="item"
            :key="item"
            v-for="item in tabList"
          ></el-tab-pane>
        </el-tabs>
      </div>
      <div class="ranking_box flex_between">
        <div class="ranking_item">
          <div class="ranking_title">{{ $transform("TOP") }}</div>
          <div class="stock_box">
            <div class="stock_item">
              <div
                v-for="(item, i) in topList"
                :key="item.shortName + item.name + '_' + i"
                class="ranking_content flex_between"
              >
                <div class="flex_start title_box">
                  <div class="title_1" @click="onNavToDetail(item)">
                    {{ item.shortName }}
                  </div>
                  <div class="add_hover flex_center">
                    <div class="box">
                      <div class="hover_box_title" v-if="item.name">
                        {{ item.name }}
                      </div>
                      <div class="hover_box_title" v-else>
                        {{ item.shortName }}
                      </div>
                      <div class="flex_start data_show_1">
                        <div class="open_data">{{ item.Open }}</div>
                        <div class="flex_start up_icon">
                          +{{ item.CHG }} (+{{ item["%CHG"] }})
                        </div>
                      </div>
                      <div class="flex_between proper_items">
                        <div class="flex_between proper_item">
                          <div class="proper_item_left">
                            {{ $transform("Open") }}
                          </div>
                          <div class="proper_item_right">{{ item.Open }}</div>
                        </div>
                        <div class="flex_between proper_item">
                          <div class="proper_item_left">
                            {{ $transform("Day High") }}
                          </div>
                          <div class="proper_item_right">
                            {{ item["Day High"] }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div @click="onNavToDetail(item)" class="title_2 one_line">
                    {{ item.name }}
                  </div>
                </div>
                <div class="progress_box flex_start">
                  <div
                    :class="
                      item['%CHG'] == 'UNCH' ? 'current_per2' : 'current_per'
                    "
                  >
                    {{ item["%CHG"] }}
                  </div>
                  <div class="process_bar" style="flex: 1">
                    <div
                      class="progress"
                      :style="{ width: item['percent'] }"
                    ></div>
                  </div>
                </div>
              </div>
              <div v-if="topList.length == 0" class="flex_center empty">
                <el-empty
                  :image-size="80"
                  :description="$transform('NO DATA')"
                ></el-empty>
              </div>
            </div>
          </div>
        </div>
        <div class="ranking_item">
          <div class="ranking_title">{{ $transform("BOTTOM") }}</div>
          <div class="stock_box">
            <div class="stock_item">
              <div
                v-for="(item, i) in bottomList"
                :key="item.shortName + item.name + '_' + i"
                class="ranking_content flex_between"
              >
                <div class="flex_start title_box">
                  <div class="title_1">{{ item.shortName }}</div>
                  <div class="add_hover flex_center right_hover">
                    <div class="box">
                      <div class="hover_box_title" v-if="item.name">
                        {{ item.name }}
                      </div>
                      <div class="hover_box_title" v-else>
                        {{ item.shortName }}
                      </div>
                      <div class="flex_start data_show_1">
                        <div>{{ item.Open }}</div>
                        <div class="flex_start up_icon reduce">
                          {{ item.CHG }} ({{ item["%CHG"] }})
                        </div>
                      </div>
                      <div class="flex_between proper_items">
                        <div class="flex_between proper_item">
                          <div class="proper_item_left">
                            {{ $transform("Open") }}
                          </div>
                          <div class="proper_item_right">{{ item.Open }}</div>
                        </div>
                        <div class="flex_between proper_item">
                          <div class="proper_item_left">
                            {{ $transform("Day Low") }}
                          </div>
                          <div class="proper_item_right">
                            {{ item["Day Low"] }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div @click="onNavToDetail(item)" class="title_2 one_line">
                    {{ item.name }}
                  </div>
                </div>
                <div class="progress_box flex_start">
                  <div class="current_per" style="color: #ce2b2b">
                    {{ item["%CHG"] }}
                  </div>
                  <div class="process_bar" style="flex: 1">
                    <div
                      class="progress"
                      :style="{ width: item['percent'] }"
                      style="background-color: #ce2b2b"
                    ></div>
                  </div>
                </div>
              </div>
              <div v-if="bottomList.length == 0" class="flex_center empty">
                <el-empty
                  :image-size="80"
                  :description="$transform('NO DATA')"
                ></el-empty>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom_tip">
      <bottom-tip></bottom-tip>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "",
      tabList: [],
      topList: [],
      bottomList: [],
    };
  },
  mounted() {
    this.loading = this.$loading();
    this.getTabList();
  },
  methods: {
    handleClick({ name }) {
      this.loading = this.$loading();
      this.getRankingList(name);
    },
    onNavToDetail(item) {
      window.parent.postMessage(
        JSON.stringify({
          type: "stockRankingDetail",

          typeName: encodeURIComponent(item.type),
          path: "/product/stock-detail",
          url: `${
            window.location.origin
          }/product/stock-detail?type=${encodeURIComponent(item.type)}`,
        }),
        "*"
      );
    },
    getTabList() {
      return this.$tool
        .fetchPost("/api/getCharts2TabList")
        .then((res) => {
          let { code, data } = res;
          this.loading.close();
          if (code == 200) {
            this.tabList = data;
            this.activeName = data[0] || "";
            this.getRankingList(this.activeName);
          }
        })
        .catch(() => {
          // this.tabList = [
          //   "S&P 500",
          //   "Nasdaq",
          //   "NYSE Composite",
          //   "EURONEXT 100 IDX",
          //   "OBX INDEX",
          //   "MADRID SE INDEX",
          // ];
          // this.activeName = this.tabList[0] || "";
          // this.getRankingList(this.activeName);
        });
    },
    getRankingList(tab) {
      return this.$tool
        .fetchPost("/api/getCharts2TabDetailList", { tab })
        .then((res) => {
          this.loading.close();
          if (res.code == 200) {
            let data = res.data;
            this.toChange(data.TOP);
            this.toChange(data.BOTTOM);
            this.topList = data.TOP;
            this.bottomList = data.BOTTOM;
          }
        })
        .catch(() => {
          this.loading.close();
        });
    },
    toPer(item) {
      return Math.abs(parseFloat(item)) + "%";
    },
    toChange(list) {
      if (list && list.length) {
        let listNumber = list.map((item) => {
          return Math.abs(parseFloat(item["%CHG"]));
        });
        let max = Math.max.apply(null, listNumber); //parseFloat(list[0]["%CHG"]);
        if (isNaN(max)) {
          list.forEach((item) => {
            item.percent = 0 + "%";
          });
          return;
        }

        list.forEach((item) => {
          item.percent = Math.abs(parseFloat(item["%CHG"]) / max) * 100 + "%";
        });
        console.log(list);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$max-width: 700px;
.ranking {
  border: 1px solid #b9c7d5;

  width: 100%;
  border-top: 4px solid #002f6c;
  box-sizing: border-box;
  padding: 0 30px;
  padding-top: 30px;
  padding-bottom: 10px;
  ::v-deep .el-tabs__header {
    margin: 0;
  }
  ::v-deep .el-tabs__nav-scroll {
    overflow-x: scroll;
    scroll-behavior: smooth;
  }
  ::v-deep .el-tabs {
    flex: 1;
    height: 20px;
  }
  ::v-deep .el-tabs__nav-wrap {
    margin: 0;
  }
  ::v-deep .el-tabs__nav-wrap::after {
    background-color: transparent;
  }
  ::v-deep .el-tabs__item.is-active {
    color: #002f6c;
  }
  ::v-deep .el-tabs__active-bar {
    background-color: #002f6c;
  }
  ::v-deep .el-tabs__item {
    color: #747474;
    padding-left: 10px;
    height: 22px;
    line-height: 20px;
    padding-right: 10px;
    font-size: 14px;
    font-family: SF-Pro-Display-Heavy;
    font-weight: 300;
    &:hover {
      color: #2e2e2e;
    }

    // margin-bottom: 5px;
  }
  .ranking_title_top {
    font-family: SF-Pro-Display-Bold;
    font-size: 16px;
    .tabs {
      width: 70%;
    }
    @media screen and (max-width: $max-width) {
      flex-direction: column;
      align-items: flex-start;
      .tabs {
        width: 100%;
      }
    }
  }
  .title {
    font-size: 24px;
    font-weight: 300;
    color: #005594;
    margin-right: 38px;
    line-height: 30px;
    font-family: SF-Pro-Display-Black;
    text-transform: uppercase;
    @media screen and (max-width: $max-width) {
      font-size: 18px;
      margin-right: 0;
    }
  }
  .ranking_box {
    padding-top: 40px;
    width: 100%;
    @media screen and (max-width: $max-width) {
      flex-direction: column;
    }
    .ranking_item {
      width: 45%;
      @media screen and (max-width: $max-width) {
        width: 100%;
        margin-bottom: 20px;
      }
      .ranking_title {
        font-size: 16px;
        margin-bottom: 20px;
        font-family: SF-Pro-Display-Bold;
        text-transform: uppercase;
        font-weight: 300;
        color: #171717;
      }
      .stock_box {
        min-height: 120px;
        .stock_item {
          .ranking_content {
            margin-bottom: 10px;
          }
          .title_box {
            width: 45%;
            @media screen and (max-width: $max-width) {
              width: 30%;
            }
            .title_1 {
              font-size: 12px;
              font-weight: 300;
              color: #4a4a4a;
              font-family: SF-Pro-Display-Heavy;
              cursor: pointer;
              &:hover {
                color: #2077b6;
              }
            }
            .add_hover {
              width: 14px;
              height: 20px;

              margin: 0 9px;
              position: relative;
              cursor: pointer;
              &::after {
                content: "";
                display: flex;
                width: 14px;
                height: 14px;
                background: url("../assets/images/hover_add.png") no-repeat
                  center center;
                background-size: 100% 100%;
              }

              .box {
                position: absolute;
                left: 0px;
                pointer-events: none;
                bottom: 20px;
                // width: 298px;
                width: 450px;
                // height: 115px;
                background: #ffffff;
                box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
                border-radius: 0px 0px 0px 0px;
                opacity: 1;
                border: 1px solid #e5e5e5;
                opacity: 0;
                border-top: 3px solid #002f6c;
                z-index: 999;
                box-sizing: border-box;
                padding: 10px 10px 9px 10px;
                transition: opacity linear 0.2;
                @media screen and (max-width: $max-width) {
                  width: 250px;
                }
                .hover_box_title {
                  font-size: 14px;
                  font-family: SF-Pro-Display-Bold;
                  font-weight: 300;
                  color: #171717;
                }
                .open_data {
                  font-family: SF-Pro-Display-Heavy;
                  color: #171717;
                  font-weight: 300;
                  font-size: 24px;
                }
                .data_show_1 {
                  font-size: 24px;
                  font-weight: 300;
                  color: #333333;
                  .up_icon {
                    font-size: 12px;
                    font-family: SF-Pro-Display-Heavy;
                    font-weight: 300;
                    color: #008456;
                    &::before {
                      content: "";
                      width: 14px;
                      height: 14px;
                      background: url("../assets/images/up_add.png") no-repeat
                        center center;
                      background-size: 100% 100%;
                      margin-left: 14px;
                    }
                    &.reduce {
                      color: #e8554e;
                      &::before {
                        background: url("../assets/images/down_reduce.png")
                          no-repeat center center;
                        background-size: 100% 100%;
                      }
                    }
                  }
                }
                .proper_items {
                  margin-top: 5px;
                  @media screen and (max-width: $max-width) {
                    flex-direction: column;
                  }
                  .proper_item_left {
                    font-family: SF-Pro-Display-Bold;
                    font-weight: 300;
                    font-size: 12px;
                    color: #747474;
                  }
                  .proper_item_right {
                    font-family: SF-Pro-Display-Bold;
                    font-weight: 300;
                    font-size: 12px;
                    color: #171717;
                  }
                  .proper_item {
                    width: 48%;
                    line-height: 30px;
                    font-size: 12px;
                    font-weight: 300;
                    color: #707070;
                    border-bottom: 1px solid #e5e5e5;
                    @media screen and (max-width: $max-width) {
                      width: 100%;
                    }
                  }
                }
              }
              &.right_hover {
                @media screen and (min-width: $max-width) {
                  .box {
                    right: 0;
                    left: unset;
                  }
                }
              }
              &:hover {
                &::after {
                  background: url("../assets/images/hoverselect.png") no-repeat
                    center center;
                  background-size: 100% 100%;
                }

                .box {
                  opacity: 1;
                  pointer-events: all;
                }
              }
            }
            .title_2 {
              flex: 1;
              font-family: SF-Pro-Display-Bold;
              font-size: 14px;
              font-weight: 300;
              color: #747474;
              cursor: pointer;
            }
          }
          .progress_box {
            width: 55%;
            @media screen and (max-width: $max-width) {
              width: 70%;
            }
            .current_per {
              font-size: 12px;
              text-align: right;
              font-weight: 300;
              color: #008456;
              margin-right: 9px;
              width: 60px;
              font-family: SF-Pro-Display-Heavy;
            }
            .current_per2 {
              font-size: 12px;
              text-align: right;
              font-weight: 300;
              color: #747474;
              margin-right: 9px;
              width: 60px;
              font-family: SF-Pro-Display-Heavy;
            }
            .progress {
              height: 16px;
              // flex: 1;
              background-color: #008465;
            }
          }
        }
      }
    }
  }
}
.bottom_tip {
  font-size: 12px;
  font-weight: 400;
  color: #707070;
  line-height: 17px;
  text-align: center;
  margin-top: 10px;
}
</style>
